import { DefaultPassThrough } from '@primevue/core'
import type { PaginatorDesignTokens } from '@primeuix/themes/types/paginator'
import Paginator, {
  PaginatorPassThroughMethodOptions,
  PaginatorPassThroughOptions
} from 'primevue/paginator'

const disabledOption = (options: PaginatorPassThroughMethodOptions<any>) => {
  return options.context.disabled
    ? {
        class: 'tw-text-interactive-disabled',
        style: 'color: var(--color-interactive-disabled); pointer-events: none;'
      }
    : {
        class: 'tw-text-interactive hover:tw-text-interactive-hover',
        style: 'color: var(--color-interactive); color: var(--color-interactive-hover);'
      }
}

export const PaginatorPassthroughConfig: DefaultPassThrough<PaginatorPassThroughOptions> = {
  firstIcon: (options: PaginatorPassThroughMethodOptions<any>) => {
    return disabledOption(options)
  },
  prevIcon: (options: PaginatorPassThroughMethodOptions<any>) => {
    return disabledOption(options)
  },
  nextIcon: (options: PaginatorPassThroughMethodOptions<any>) => {
    return disabledOption(options)
  },
  lastIcon: (options: PaginatorPassThroughMethodOptions<any>) => {
    return disabledOption(options)
  },
  page: (options: PaginatorPassThroughMethodOptions<any>) => {
    return {
      class: options.context.active && 'tw-font-bold',
      style: options.context.active && 'font-weight: 700;' // TODO: Remove when Tailwind is fully supported
    }
  }
}

export const PaginatorStyleConfig: PaginatorDesignTokens = {
  root: {
    padding: '0px',
    gap: '8px'
  },
  navButton: {
    borderRadius: 'var(--border-radius-sm)',
    hoverBackground: 'transparent',
    hoverColor: 'var(--color-interactive-hover)',
    selectedBackground: 'var(--color-surface-default)',
    selectedColor: 'var(--color-interactive)',
    focusRing: {
      width: '0',
      color: 'var(--color-interactive-pressed)'
    },
    color: 'var(--color-interactive)',
    width: 'auto',
    height: 'auto',
    background: 'transparent'
  },
  currentPageReport: {
    color: 'var(--color-text)'
  }
}

export default Paginator
